import axios from 'axios'

function normalizeApiBaseUrl(value) {
  const raw = String(value ?? '').trim()
  if (!raw) return '/api'

  // Allow same-origin shorthand.
  if (raw.startsWith('/')) {
    return raw.startsWith('/api') ? raw.replace(/\/+$/, '') : '/api'
  }

  let url
  try {
    url = new URL(raw)
  } catch {
    return '/api'
  }

  const origin = url.origin
  const path = (url.pathname || '').replace(/\/+$/, '')

  // Accept both:
  // - https://backend.example.com        -> https://backend.example.com/api
  // - https://backend.example.com/api    -> https://backend.example.com/api
  // - https://backend.example.com/api/   -> https://backend.example.com/api
  if (!path || path === '/') return `${origin}/api`
  if (path === '/api') return `${origin}/api`
  if (path.endsWith('/api')) return `${origin}${path}`
  return `${origin}/api`
}

const baseURL = normalizeApiBaseUrl(import.meta.env.VITE_API_URL)

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 120000  // 2 minutes timeout for AI responses
})

// Request interceptor to add user ID to headers
api.interceptors.request.use((config) => {
  const userStr = localStorage.getItem('user');
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // x-user-id header REMOVED (Security Fix: auth now relies solely on JWT Bearer token)
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor to handle global 401 Unauthorized errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = String(error?.config?.url ?? '')
    const isAuthEndpoint =
      url.includes('/login') ||
      url.includes('/demo-login') ||
      url.includes('/register') ||
      url.includes('/resend-verification')

    // If the error is 401 and it's not an auth request, redirect to login
    if (error.response && error.response.status === 401) {
      if (error.config && !isAuthEndpoint) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login?expired=true';
      }
    }
    return Promise.reject(error);
  }
);

export default api

